import React, { Component } from "react";
import "./Tnc.scss";
import TncLogos from "../../../assets/images/newlogo.svg";
import { Image } from "react-bootstrap";
class Tnc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInviteVendors: false,
      allCustomers: [],
      pageno: 1,
      records: 10,
      sort: "",
      keyword: "",
      search: "",
      totalOrders: [],
    };
  }

  componentDidMount() {
    console.log("tnc page");
  }
  handleRouteChange(val) {
    this.props.history.push(val);
  }

  render() {
    return (
      <section class="terms-section">
        <div class="container">
          <div className="mx-auto mt-4 mb-4 d-flex justify-content-start">
            <Image
              src={TncLogos}
              alt="Tnc Logo"
              className="img-fluid pointer"
              onClick={() => this.handleRouteChange("/dashboard")}
            />
          </div>
          {/* page headings */}
          <div className="text-center">
            <h1 class="heading overflow-hidden mt-0 mb-2">WAZZHERE LLC</h1>
            <h2 className="headingh2 mt-0 mb-4">DelivaHere</h2>

            <h3 class="headingh2 overflow-hidden mb-0">
              <span class="d-block">Service Privacy Policy</span>
            </h3>
            <p>March 18th, 2025</p>
          </div>
          <div class="row">
            <div class="col-md-12">
              {/* Introduction */}
              <h2 class="heading3 text-black mb-2 mt-3">1. Introduction:</h2>
              <p>
                WAZZHERE LLC, a Texas, USA Company also registered in Nigeria as
                WAZZHERE LTD (hereinafter, “We,” “Our,” or “Us”), is committed
                to protecting the privacy of its Users (as defined herein
                below). This Privacy Policy (hereinafter, "Privacy Policy")
                outlines what information WAZZHERE LLC collects and uses from
                its Users through the mobile application, its websites{" "}
                <a href="http://www.wazzhere.com/" target="_blank">
                  www.wazzhere.com
                </a>
                ,{" "}
                <a href="http://www.delivahere.com/" target="_blank">
                  www.delivahere.com
                </a>
                , the mobile application,{" "}
                <a href="http://www.delivahere.com/" target="_blank">
                  DelivaHere
                </a>
                , and other products and services offered by WAZZHERE LLC
                (collectively hereinafter the "Service"). The mobile application
                may at times be individually referred to as “Application” and
                the website may at times be individually referred to as
                “Website.” WAZZHERE LLC will only keep Users’ information, which
                they submit through the Service for internal use. If any
                provision of this Privacy Policy conflicts with one or more
                provisions of Service Terms and Conditions, the provisions of
                Service Terms and Conditions shall control.{" "}
                <b>
                  If User does not accept this Privacy Policy (including any
                  updated terms hereto) or does not meet or comply with these
                  provisions, then User may not use this Service. Service Terms
                  and Conditions is incorporated herein by reference and User by
                  using the Service hereby agrees that User shall comply with
                  Service Terms and Conditions and Privacy Policy. Please be
                  advised that WAZZHERE LLC reserves the right to release such
                  information to law enforcement or other governmental officials
                  if in WAZZHERE LLC's sole and absolute discretion, it is
                  deemed necessary to comply with the law.
                </b>{" "}
              </p>
              <p>
                <b>
                  If you are a user accessing the Service from the European
                  Union, Asia, Africa, Americas or any other region with laws or
                  regulations governing personal data collection, use, and
                  disclosure that differ from United States laws, please be
                  advised that through your continued use of the Website or
                  Application which are governed by united states law, this
                  privacy policy, and our end user license agreement, you may be
                  transmitting your personal information to countries (including
                  the united states) where laws regarding processing personal
                  information may be less stringent than processing of personal
                  information in your country and you hereby consent to such
                  transmission of personal information.
                </b>
              </p>

              {/* Revisions to Privacy Policy */}
              <h2 class="heading3 text-black mb-2 mt-4">
                2. Revisions to Privacy Policy
              </h2>
              <p>
                WAZZHERE LLC reserves the right to revise, change, amend, alter
                or modify (hereinafter, "Update") this Privacy Policy and its
                other policies and agreements at any time and in any manner. The
                User, as defined below, is responsible for periodically checking
                for any Updates of this Privacy Policy. We may also notify you
                of any changes to our Privacy Policy by posting the new Privacy
                Policy on our Service at{" "}
                <a href="http://www.wazzhere.com/privacy" target="_blank">
                  www.wazzhere.com/privacy
                </a>
                ,{" "}
                <a href="http://www.delivahere.com/privacy" target="_blank">
                  www.delivahere.com/privacy
                </a>
                , and/or via email. Any Updates supersede any prior versions
                immediately upon posting on the Service. Using the Service after
                any such Update or changes to the Privacy Policy shall
                constitute consent to changed terms or practices.
              </p>

              {/* Information Collected */}
              <h2 class="heading3 text-black mb-2 mt-4">
                3. Information Collected
              </h2>
              <p>
                The information which WAZZHERE LLC collects through the Service
                may include Personal Information (hereinafter the "Personal
                Information") which refers to information that helps it identify
                users or viewers of the Service (collectively, "Users" and each
                a "User" or “You” and shall refer to Registered User (as defined
                herein below). The Personal Information includes but shall not
                be limited to data such as a User’s name, street address, phone
                number, facsimile number, email address, username, password, and
                financial information (for agents). Users are responsible for
                keeping all Personal Information current and may change any
                previously entered information through the Service in the manner
                set forth below. WAZZHERE LLC may utilize Personal Information,
                without limitation, for the following purposes: (i) establishing
                and verifying user identities; (ii) opening, maintaining,
                administering and servicing Registered User accounts; (iii)
                processing, servicing or enforcing transactions and sending
                communications relating to the Service; (iv) providing User
                support in connection with User-use of the Service; (v)
                providing updates for the Service; (vi) providing promotional
                notices and offers and other WAZZHERE LLC information; (vii)
                responding to User-posed inquiries and comments; (viii)
                maintaining the security of the Service and Company-systems; and
                (ix) evaluating Use of the Service for potential improvements
                and otherwise. The Service may also collect data that cannot be
                traced back to a specific individual (hereinafter the "Anonymous
                Information"). For example, WAZZHERE LLC may be able to keep
                count of how many Users have viewed the Service and specific
                content therein, or key words utilized to find the Service, but
                this information does not necessarily include information
                regarding Users names, street addresses, phone numbers or email
                addresses. Users who view the Service but do not enter their
                Personal Information are generally anonymous Users. Only
                Anonymous Information and no Personal Information will be
                intentionally collected by WAZZHERE LLC from anonymous Users.
                The Service may use browser cookies to collect Anonymous
                Information. The Service may also incorporate web beacons or
                similar tracking technologies to allow WAZZHERE LLC to track how
                the Service is used. Such technologies are used to collect
                Anonymous Information, e.g. the name of the User’s internet
                service provider, the IP address of the User’s computer, User’s
                browser software and operating system, the identity of any
                linked-form or linked-to website and other similar information.
                Furthermore, WAZZHERE LLC may, either directly or through a
                third party, track Users’ conduct on the Service, including,
                without limitation, areas of the Service visited, topic(s)
                viewed, most popular pages of the Service, Users’ Internet
                connection type and browser use WAZZHERE LLC may combine a
                User’s Anonymous Information with similar information collected
                from other Users to help improve the Service.
              </p>

              <p>
                <b>3.1</b> We disclaim any liability for disclosure of any
                Personal Information or non-Personal Information arising out of
                any of the following circumstances:
                <ol>
                  <li>
                    Disclosure to government (local, state, national, or
                    international) agencies in response to legal processes, such
                    as subpoenas or court order; or
                  </li>
                  <li>
                    Any unlawful or unauthorized access to and transmissions of
                    Personal Information from the Service; or
                  </li>
                  <li>
                    Disclosure of any information by the User themselves on
                    message boards, public forums, blogs, social networking
                    websites, or any other online or offline media.
                  </li>
                </ol>
              </p>

              <p>
                <b>3.2</b> The use of some features of the Service requires the
                User to register using a simple registration form. Through the
                form, Personal Information is collected and additionally
                Personal Information is collected at different stages and at
                different times of the Users use of this Service. This Personal
                Information may include, but shall not be limited to: the User's
                name, Company name, physical addresses, email address, telephone
                number, fax no., credit card information or other
                financial/transactional information, relationship status, place
                of study, employer, gender, photographs, video recordings, audio
                recordings, text notes, contact information, etc. While
                collecting such Personal Information from the Users, we take
                great care and diligence in collecting only as much information
                as is absolutely vital to provide the User with efficient and
                timely services. All such Personal Information is kept
                confidential and never shared with, or sold to, or traded with,
                any third party without your explicit consent.
              </p>

              <p>
                <b>3.3</b> Some of the instances when we collect Personal
                Information from the Users of this Service include:
                <ol>
                  <li>during registration process; or</li>
                  <li>
                    while subscribing to our different products and/or features;
                    or
                  </li>
                  <li>
                    while completing an online form to request information about
                    our products and/or services.
                  </li>
                  <li>When you use the blog or contact us features.</li>
                </ol>
              </p>

              <p>
                <b>3.4</b> Some of the uses of the Personal Information so
                collected by our Service include:
                <ol>
                  <li>
                    to allow the User to access special features reserved for
                    our registered members; or{" "}
                  </li>
                  <li>
                    {" "}
                    to provide the User the information requested from us; or
                  </li>
                  <li>
                    {" "}
                    to register the User for our seminars, forums, contests, and
                    online chats; or{" "}
                  </li>
                  <li>to contact the User when requested; or </li>
                  <li>
                    {" "}
                    to make purchases, respond to offers, or download features
                    from Service; or{" "}
                  </li>
                  <li>
                    to provide such information to our affiliates and partners
                    (if any) under confidentiality agreement so that they may
                    provide the User with offers and information about products
                    or services the User might be interested in.
                  </li>
                </ol>
              </p>

              <p>
                <b>3.5</b> The User can always disallow us to contact the User
                regarding the latest offers, news, and updates, by opting out at
                the time of registration or by sending an email to{" "}
                <a href="mailto:terms@wazzhere.com" target="_blank">
                  terms@wazzhere.com
                </a>{" "}
                or{" "}
                <a href="mailto:terms@delivahere.com" target="_blank">
                  terms@delivahere.com
                </a>
                .
              </p>

              <p>
                <b>3.6</b> Besides the above-mentioned Personal Information,
                some non-Personal Information may be collected when the User
                accesses the Service. Such non-Personal Information may include
                the type of browser the User used to access the Service, the
                operating system(s) installed on the User’s computer, internet
                protocol (ip) address of the User’s computer, ip address of the
                User’s internet service provider (isp), etc. When you use a
                mobile device, the following information is automatically
                collected: the type of mobile device used, the mobile device's
                unique device ID, the mobile operating system of the device, the
                type of mobile internet browser used, and information about the
                way You use the Service. This information is generally used to
                improve the layout and content of our Service, provide the User
                with customized advertisements, analyze the usage of the
                Service, dispense with the need to re-login every time the User
                visits and logs into the Service, and enhance the overall
                experience of using the Service. All such non-Personal
                Information is kept confidential and never shared with, or sold
                to, any third party.
              </p>

              <p>
                <b>3.7 Cookies</b> Cookies are small text files that are placed
                on the Users hard disk by our secured servers. These cookies are
                used to collect non-Personal Information. Cookies help Us in
                gathering information, like how the User uses our Service, how
                the User uses our services, types of data accessed, times and
                volume of use, duration of sessions and other similar usage. Our
                cookies are safe, and do not, in any way, compromise the User’s
                privacy while the User is using our Service. Third party vendors
                may also use cookies to serve advertisements on our Service. A
                User can also disable the cookies by adjusting the internet
                browser preferences on their computer/electronic devices.
                However, we advise you to receive cookies sent by our Service.
                By visiting or using our Service you consent to the placement of
                cookies in your browser in accordance with this Privacy Policy.
              </p>

              <p>
                <b>3.8</b> We accord maximum priority to the security of all the
                data we collect from the Users and/or Registered Users of this
                Service. Therefore, we use the latest and most secure
                technologies prevalent in the industry and available in the
                market to protect the integrity of all the Personal Information
                or non-Personal Information collected during the course of your
                interaction with the Service. Apart from several electronic and
                technical safeguards, we also employ certain physical and
                procedural safeguards in order to make the access to this
                sensitive data exclusive to the authorized personnel have access
                to this data. Notwithstanding any amount of steps and assurances
                we give, due to peculiar nature of the Web, no foolproof
                security from unauthorized access by hackers, crackers, or
                similar illegal means and personnel, can be guaranteed.
                Additionally, while processing online payments, we do not retain
                or intercept any credit card data which you submit through our
                secure servers. All such data is directly sent to the secured
                servers of the credit card companies through latest SSL
                encryption method for further processing
              </p>

              {/* Registered Users */}
              <h2 class="heading3 text-black mb-2 mt-4">4. Registered Users</h2>
              <p>
                A User may become a registered member of the Service in
                accordance with the Service Terms and Conditions (hereinafter
                the "Registered User"), in which case the User may be asked to
                provide the following information: Personal Information,
                including his or her name, address, telephone number, email
                address, a unique login name, password and password validation,
                a password hint to help the User remember his password. This
                information is collected within the registration process, in
                order to allow for greater ease in the Registered User utilizing
                the Service and its interactive features; to allow WAZZHERE LLC
                and the Service to identify the Registered User; and to allow
                WAZZHERE LLC to contact the Registered User for customer service
                purposes and otherwise. In addition, WAZZHERE LLC requests
                Registered User’s email address to confirm new member
                registration and to enable email or other electronic
                communications to be made through the Service. Moreover,
                WAZZHERE LLC may utilize a Registered User’s email address to
                send updates, newsletters, news or other information regarding
                the Service to the Registered User. In the event that Registered
                User no longer wishes to receive such emails, Registered User
                may "opt-out" by contacting WAZZHERE LLC by sending an email at
                terms@wazzhere.com or terms@delivahere.com. The subject line of
                that communication should read: "DO NOT SEND ME NOTIFICATION
                EMAILS." Registered Users may be providing more Personal
                Information than general Users to the Service. By becoming a
                Registered User that User assumes all risk and agrees to these
                terms with regard to all of the information that he submits
                vis-à-vis the Service. Furthermore, the information set forth in
                the Registered User’s profile may be shared with others, and
                registration as a Registered User constitutes consent to sharing
                this information.
              </p>

              {/* User Posted Content */}
              <h2 class="heading3 text-black mb-2 mt-4">
                5. User Posted Content
              </h2>
              <p>
                Users may post content, including, without limitation, on the
                Service that may be made publicly available to other users and
                to the general public via the Service. Users acknowledge and
                agree that any posted comments posted by User do not reflect the
                Service or WAZZHERE LLC Users acknowledge and agree that by
                posting or otherwise submitting such content on or to the
                Service, User’s Personal Information, including his email
                address and any other information the User supplies may be
                visible to the third parties. User shall not share any
                information in his inquiry that he is not prepared to be public
                or to otherwise share with such other third parties. Further,
                Users may submit inquiries, comments or other content
                (collectively, an "Inquiry") to WAZZHERE LLC through the
                Service. Users acknowledge and agree that by sending an Inquiry
                or otherwise posting communications to the Service, a User’s
                Personal Information, including his email address and any other
                information the User supplies, may be visible to third parties.
                User shall not share any information in his Inquiry that he is
                not prepared to be public or to otherwise share with such other
                third parties. Moreover, User’s Inquiry may be available for
                review by WAZZHERE LLC and/or other Users’ contractors and
                employees. Moreover, WAZZHERE LLC may from time to time, use
                third party email servers to send and track receipt of the
                Inquiries, and analyze the pattern of inquiry usage via these
                third-party tracking systems. If a User is making an Inquiry or
                posting content for someone other than himself, in which another
                person’s Personal Information will be accessible or otherwise
                made available, User hereby makes the material representation
                and warranty upon which he wishes WAZZHERE LLC to reasonably
                rely, that he has obtained each of those other individuals’
                consent to disclose their personal information to WAZZHERE LLC
                and other Users. All submissions of content, including without
                limitation, the posting of content to the Service or the
                submission of an Inquiry, sent to WAZZHERE LLC are accepted in
                accordance with, and governed by, the Service Terms and
                Conditions. Moreover, User acknowledges and agrees that this
                Privacy Policy does not apply to content, business information,
                pictures, ideas, concepts or inventions that User sends to
                WAZZHERE LLC (collectively, "Submitted Property"). User
                acknowledges and agrees that all Submitted Property becomes the
                property of WAZZHERE LLC immediately upon its receipt of the
                same, unless WAZZHERE LLC elects not to take ownership of said
                property. WAZZHERE LLC may then utilize, distribute or otherwise
                disseminate the Submitted Property as it wishes in its sole
                discretion. As it relates to intellectual property rights
                relating to the same, User hereby assigns and conveys all rights
                he may have to such submitted property and ideas. If User seeks
                to keep such information or property private or proprietary, he
                should not send such information to WAZZHERE LLC.
              </p>

              {/* Third Party Advertisers and Links to Third-Party Websites */}
              <h2 class="heading3 text-black mb-2 mt-4">
                6. Third Party Advertisers and Links to Third-Party Websites
              </h2>
              <p>
                The Service may include advertisements, and offers of products
                and services from third-party companies which may include links
                to third-party websites. The advertisements and offers placed by
                these companies, or other listings of other Users are not
                affiliated, owned, maintained or updated by WAZZHERE LLC. If
                User visits the website of these third-party advertisers, or
                otherwise submits information to any other User, they may use
                cookies and/or request and collect User’s Personal Information.
                WAZZHERE LLC does not know of the policies of these independent
                third-party advertisers, including without limitation, other
                Users, and is not responsible for the information collected or
                how the information is used by any third-party advertisers,
                including without limitation, other Users. WAZZHERE LLC also
                cannot confirm or in any way guarantee the accuracy of the
                information provided by those third-party advertisers on their
                websites. WAZZHERE LLC strongly recommends that User reads and
                reviews the terms and conditions, and privacy policies of any
                other third-party websites that it may view. The Service may
                contain links to third-party websites of promoters, advertisers,
                affiliates, partners, agents, etc. However, we do not draft,
                review, control or monitor the privacy practices of such
                third-party websites. Should the User choose to visit these
                linked websites, the User’s visit and/or use of such linked
                websites shall be subject to the privacy policies of such
                third-party websites. We strongly advise you to review the legal
                documents of such linked websites before entering into any
                transaction.
              </p>

              {/* Information Sharing */}
              <h2 class="heading3 text-black mb-2 mt-4">
                7. Information Sharing
              </h2>
              <p>
                Except as otherwise provided in this Privacy Policy, WAZZHERE
                LLC will not intentionally distribute, rent or sell a User’s
                Personal Information, User posted content, or other information
                collected from the User to third parties without the User’s
                permission. Notwithstanding the foregoing, WAZZHERE LLC may be
                required by law enforcement or judicial authorities to provide
                Users’ Personal Information to the appropriate governmental
                authorities. If WAZZHERE LLC receives a request from law
                enforcement or judicial authorities, then it reserves the right
                to provide the requested information. In addition, WAZZHERE LLC
                reserves the right to release such information to law
                enforcement or other governmental officials as, in WAZZHERE
                LLC’s sole and absolute discretion, it is deemed necessary to
                comply with the law. WAZZHERE LLC may also disclose such User
                information to Our trusted service providers who work on Our
                behalf and have agreed to abide by the terms of this Privacy
                Policy. WAZZHERE LLC may also disclose such User information to
                Our trusted third parties who assist us in providing services to
                and operating the Website and Application, or otherwise
                conducting our business, so long as those parties agree to keep
                this information confidential. WAZZHERE LLC may also disclose
                such non-personally identifiable User information to other
                parties for marketing, advertising or other uses.
              </p>

              {/* Security Procedures */}
              <h2 class="heading3 text-black mb-2 mt-4">
                8. Security Procedures
              </h2>
              <p>
                WAZZHERE LLC undertakes reasonable efforts to operate secure
                data networks which are protected by industry standard firewall
                and password protection systems. WAZZHERE LLC undertakes
                reasonable efforts to review its security and privacy policies
                on a periodic basis and it may adjust and change the systems as
                necessary. All supplied sensitive/credit information is
                transmitted via Secure Socket Layer (SSL) technology and only is
                only accessible to those authorized with special access rights
                to such systems; such individuals are further required to keep
                this information confidential. After any financial transaction
                on Service, all the Users private information (credit cards,
                social security numbers, and any other related personal or
                financial information) shall not be stored on our servers.
                Notwithstanding the above, and although WAZZHERE LLC is ever
                diligent in its security pursuits, it cannot guarantee the
                success of its efforts.{" "}
                <em>
                  Note: The servers used by WAZZHERE LLC for storing your
                  personal information is owned and hosted by Amazon Web
                  Services LLC, which is an Amazon.com company. For more
                  information on steps taken by Amazon to protect the security
                  interest of their servers and Your personal information please
                  review the following:{" "}
                </em>
                <em>
                  <a
                    href="https://docs.aws.amazon.com/whitepapers/latest/introduction-aws-security/welcome.html"
                    target="_blank"
                  >
                    https://docs.aws.amazon.com/whitepapers/latest/introduction-aws-security/welcome.html
                  </a>
                </em>
              </p>

              {/* Collection and Use of Location Data */}
              <h2 class="heading3 text-black mb-2 mt-4">
                9. Collection and Use of Location Data
              </h2>
              <p>
                DelivaHere collects the location details of Delivery Partners to
                determine when a delivery request is relevant to them, based on
                their current location or when the request aligns with their
                subscribed routes. Additionally, DelivaHere collects Delivery
                Agents’ location data to provide real-time tracking information
                to the sender who initiated the package delivery request.
              </p>

              {/* Special Cases */}
              <h2 class="heading3 text-black mb-2 mt-4">10. Special Cases</h2>
              <p>
                It is WAZZHERE LLC's policy to not use or share the Personal
                Information about the Users of the Service in ways which have
                not been outlined or described herein without first allowing its
                Users a chance to opt out or otherwise disallow such unrelated
                uses. However, WAZZHERE LLC may disclose Personal Information
                about its Users or information relating to their Use of the
                Service for any reason if, in its sole discretion, it determines
                that it is reasonable to do so, including:
              </p>
              <p>
                <b>10.1</b> To comply with laws, such as the Electronic
                Communications Privacy Act, regulations or governmental or legal
                requests for such information;
              </p>
              <p>
                <b>10.2</b> To reveal information that is needed to identify,
                contact or bring legal action against any User who may be
                violating the Service Terms and Conditions;
              </p>
              <p>
                <b>10.3</b> To operate the Service properly;
              </p>
              <p>
                <b>10.4</b> To protect the Service and its Users; and/or
              </p>
              <p>
                <b>10.5</b> To fully cooperate with law enforcement authorities,
                private-party litigants and others seeking information about its
                Users to the extent required by applicable law.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Tnc;
